import React, { useEffect, useState } from "react";
import { DataTable } from 'primereact/datatable';
import './ControlEquipamiento.scss';
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Sidebar } from "primereact/sidebar";
import { getCitas, getOperadoresDisponibles } from "./Integracion";
import { Calendar } from "primereact/calendar";
import { formateoBasico } from "../../../utilidades/formateos";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

const EVIDENCIA_BASE_URL = "https://repo.sumaenlinea.mx/equipamiento/";
export const ControlEquipamiento = () => {

    const [filtros, setFiltros] = useState({
        fecha_inicio: new Date(),
        fecha_fin: new Date(),
        id_unidad: null,
        id_chofer: null,
    })
    const [operadores, setOperadores] = useState([])
    const [result, setResult] = useState([])
    const [sidebarVisible, setSidebarVisible] = useState(false)
    const [selectedRow, setSelectedRow] = useState(null)


    // evidencia1.jpg
    // get data
    useEffect(() => {
        getOperadoresDisponibles().then((res) => {
            setOperadores(res);
        })
        fetchData();
    }, [])
    const fetchData = async () => {
        try {
            const params = {
                fecha_inicio: formateoBasico(filtros.fecha_inicio),
                fecha_fin: formateoBasico(filtros.fecha_fin),
                id_unidad: filtros.id_unidad ? filtros.id_unidad : null,
                id_chofer: filtros.id_chofer ? filtros.id_chofer.code : null,
            }
            const result = await getCitas(params);
            setResult(result);
        } catch (error) {
            console.log("error", error);
        }
    }
    // templates
    const STATUS_MAP = {
        1: { label: "PROGRAMADO", severity: "info" },
        2: { label: "EN ESPERA", severity: "warning" },
        3: { label: "EN PROCESO", severity: "secondary" },
        4: { label: "COMPLETADO", severity: "success" },
        5: { label: "CANCELADO", severity: "danger" },
        6: { label: "NO ASISTIÓ", severity: "danger" },
    };

    const getStatus = (id) => STATUS_MAP[Number(id)];

    const statusTemplate = (rowData) => {
        const status = getStatus(rowData.ID_ESTATUS);
        return (
            <Tag severity={status?.severity ?? null}>
                {status?.label ?? rowData.ESTATUS}
            </Tag>
        );
    };

    const detalleStatusTemplate = (val) => {
     
        
        const hecho = val === 1 || val === true || val === '1' || val === 'true';
        return (
            <Tag severity={hecho ? 'success' : 'danger'}>
                {hecho ? 'SE HIZO' : 'NO SE HIZO'}
            </Tag>
        );
    };

    const onRowClick = (e) => {
        const detalle = e.data.DETALLE_EQUIPAMIENTO;
        const parsed = typeof detalle === "string" ? JSON.parse(detalle) : detalle;
        setSelectedRow({ ...e.data, DETALLE_EQUIPAMIENTO: parsed });
        setSidebarVisible(true);
    };

    return (
        <div className="ControlEquipamiento">
            <div className="filtros">
                <div className="filtro">

                    <Calendar
                        value={filtros.fecha_inicio}
                        onChange={(e) => setFiltros({ ...filtros, fecha_inicio: e.value })}
                        dateFormat="dd/mm/yy"
                        showIcon
                        className="w-full"

                    />
                </div>
                <div className="filtro">

                    <Calendar
                        value={filtros.fecha_fin}
                        onChange={(e) => setFiltros({ ...filtros, fecha_fin: e.value })}
                        dateFormat="dd/mm/yy"
                        showIcon
                        className="w-full"
                    />
                </div>
                <div className="filtro">

                    <InputText
                        value={filtros.id_unidad}
                        onChange={(e) => setFiltros({ ...filtros, id_unidad: e.target.value })}
                        placeholder="Unidad"
                        type="number"
                        style={{ maxWidth: '100px' }}
                    ></InputText>
                </div>
                <div className="filtro">

                    <Dropdown
                        value={filtros.id_chofer}
                        options={operadores}
                        optionLabel="name"
                        onChange={(e) => setFiltros({ ...filtros, id_chofer: e.value })}
                        placeholder="Operador"
                        filter
                        showClear
                    ></Dropdown>
                </div>
                <div className="buttonContainer">
                    <Button style={{ marginBottom: '14px' }} label="Buscar" className="button" onClick={fetchData} />
                </div>
            </div>
            <Sidebar
                visible={sidebarVisible}
                onHide={() => setSidebarVisible(false)}
                position="right"
                className="detalle-sidebar-panel"
                header={
                    <div className="sidebar-title">
                        <i className="pi pi-wrench" />
                        <span>Detalle de Equipamiento</span>
                    </div>
                }
            >
                {selectedRow && (
                    <div className="detalle-sidebar">

                        {/* ── Info general ── */}
                        <div className="detalle-header">
                            <div className="info-field">
                                <span className="info-label">Unidad</span>
                                <span className="info-value">{selectedRow.UNIDAD}</span>
                            </div>
                            <div className="info-field">
                                <span className="info-label">Fecha</span>
                                <span className="info-value">{selectedRow.FECHA}</span>
                            </div>
                            <div className="info-field">
                                <span className="info-label">Técnico</span>
                                <span className="info-value">{selectedRow.USUARIO_TECNICO}</span>
                            </div>
                            <div className="info-field">
                                <span className="info-label">Usuario</span>
                                <span className="info-value">{selectedRow.USUARIO}</span>
                            </div>
                        </div>

                        {/* ── Lista equipamientos ── */}
                        <p className="section-label">Equipamientos ({(selectedRow.DETALLE_EQUIPAMIENTO ?? []).length})</p>

                        <div className="detalle-items">
                            {(selectedRow.DETALLE_EQUIPAMIENTO ?? []).map((item, idx) => (
                                <div key={idx} className="detalle-item">
                                    <div className="detalle-item-header">
                                        <span className="equipamiento-nombre">{item.EQUIPAMIENTO}</span>
                                        {detalleStatusTemplate(item.STATUS_EQUIPAMIENTO)}
                                    </div>
                                    {item.EVIDENCIA && (
                                        <div className="evidencia-wrap">
                                            <img
                                                src={`${EVIDENCIA_BASE_URL}${item.EVIDENCIA}`}
                                                alt={item.EQUIPAMIENTO}
                                                className="evidencia-img"
                                            />
                                        </div>
                                    )}
                                    {item.OBSERVACIONES && (
                                        <div className="observaciones-box">
                                            <span className="obs-label">Observaciones</span>
                                            <span className="obs-text">{item.OBSERVACIONES}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </Sidebar>

            <DataTable
                value={result}
                scrollHeight="400px"
                scrollable
                scrollDirection="both"
                onRowClick={onRowClick}
                rowHover
            >
                <Column field="ID" header="ID"></Column>
                <Column field="FECHA" header="Fecha"></Column>
                <Column field="ID_BITACORA" header="Bitacora"></Column>
                <Column field="UNIDAD" header="Unidad"></Column>
                <Column field="OPERADOR" header="Operador"></Column>
                <Column field="ESTATUS" header="Estatus" body={statusTemplate}></Column>
                <Column field="HORA_ARRIBO" header="Hora de Llegada" ></Column>
                <Column field="HORA_SALIDA" header="Hora de Salida" ></Column>
                <Column field="USUARIO_TECNICO" header="Técnico" ></Column>

            </DataTable>
        </div>
    )
}
export default ControlEquipamiento;